import { type MediaControls, type MediaEvent } from '.'
import { error } from '../../utils/logger'

export class HtmlMediaElementControls implements MediaControls {
  mediaEl: HTMLMediaElement
  constructor (mediaEl: HTMLMediaElement) {
    this.mediaEl = mediaEl
  }

  on (ev: MediaEvent, handler: (data: any) => void): HtmlMediaElementControls {
    this.mediaEl?.addEventListener(ev, handler)
    return this
  }

  off (ev: MediaEvent, handler: (data: any) => void): HtmlMediaElementControls {
    this.mediaEl?.removeEventListener(ev, handler)
    return this
  }

  play () {
    this.mediaEl.play().catch(error)
  }

  pause () {
    this.mediaEl.pause()
  }

  get paused (): boolean {
    return this.mediaEl.paused
  }

  get currentTime (): number {
    return this.mediaEl.currentTime
  }

  get duration (): number {
    return this.mediaEl.duration
  }

  get currentSrc (): string | undefined {
    return this.mediaEl.src
  }

  setCurrentTime (seconds: number) {
    this.mediaEl.currentTime = seconds
  }

  mute (muted: boolean) {
    this.mediaEl.muted = muted
  }

  setVolume (value: number) {
    this.mediaEl.volume = value
  }

  getVolume (): number {
    return this.mediaEl.volume
  }
}
